import React from 'react';
import { DropdownSelect, Price } from 'components';
import { t } from 'ttag';
import { Field } from 'formik';
import PropTypes from 'prop-types';

function PlayerFlag({ playerFlagOptions, hasChoice }) {
  /**
   * @type {{label: string, value: number}[]}
   */
  const options =
    playerFlagOptions &&
    playerFlagOptions.selections &&
    playerFlagOptions.selections.map((selection) => {
      const {
        value,
        image,
        title,
        number: playerNumber,
        name: playerName,
        original: isOriginal,
      } = selection;
      return {
        value,
        label: (
          <div className="flex items-center space-x-2">
            {image && <img className="h-6 w-6" src={image} alt={title || ''} />}
            <span className="text-sm text-dark-gray">
              {title ||
                `${playerNumber || ''} ${playerName || ''} ${
                  isOriginal ? '(Original)' : ''
                }`}
            </span>
          </div>
        ),
      };
    });

  if (playerFlagOptions && playerFlagOptions.isVisible)
    return (
      <div>
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-bold uppercase">
            {playerFlagOptions.player_flag_type === 'player'
              ? t`Add Player name`
              : playerFlagOptions.title}
          </span>
          {!hasChoice && playerFlagOptions.price && (
            <Price
              unitPrice={playerFlagOptions.price}
              priceSize="xs"
              priceFontWeight="semibold"
            />
          )}
        </div>

        <Field name={playerFlagOptions.name}>
          {({ form, field }) => (
            <DropdownSelect
              options={options}
              name={field.name}
              value={
                options
                  ? options.find((option) => option.value === field.value)
                  : ''
              }
              onChange={(option) =>
                form.setFieldValue(field.name, option.value)
              }
              onBlur={field.onBlur}
              isValid={field.value !== 0}
              isSearchable={false}
            />
          )}
        </Field>
      </div>
    );
  return null;
}

PlayerFlag.propTypes = {
  playerFlagOptions: PropTypes.shape({
    price: PropTypes.string,
    customization_image: PropTypes.string,
    name: PropTypes.string,
    player_flag_type: PropTypes.oneOf(['player', 'engraving']),
    title: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.number,
    selections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.number,
        image: PropTypes.string,
      })
    ),
    isVisible: PropTypes.bool,
  }),
  hasChoice: PropTypes.bool,
};

PlayerFlag.defaultProps = {
  playerFlagOptions: undefined,
  hasChoice: false,
};

export default PlayerFlag;
